import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Plus, LogOut, Users, ShoppingCart } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header = () => {
  const location = useLocation();
  const { logout } = useAuth();
  const isAdminPage = location.pathname === '/admin';

  const handleLogout = async () => {
    if (window.confirm('确定要退出登录吗？')) {
      await logout();
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <h1><img src="/android-chrome-192x192.png" alt="logo" style={{ width: 64, height: 64, marginRight: 8, verticalAlign: 'middle' }} /> 猪淇林精选</h1>
          </Link>

          <nav className="nav">
            <Link to="/add-recipe" className="nav-link add-recipe-btn">
              <Plus size={16} />
              添加食谱
            </Link>

            <Link to="/cart" className="nav-link">
              <ShoppingCart size={16} />
              购物清单
            </Link>

            {isAdminPage ? (
              <button onClick={handleLogout} className="nav-link admin-btn">
                <LogOut size={16} />
                退出登录
              </button>
            ) : (
              <Link to="/admin" className="nav-link admin-btn">
                <Users size={16} />
                管理用户
              </Link>
            )}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
